module.exports = __webpack_public_path__ + "static/media/flag.23e130b1.svg";